import { SKILL_CATEGORY } from "./skill-category-urls";
import { SKILL_GENERATION } from "./skill-generation-urls";
import { SURVEY_CONFIGURATION, SURVEY_PARTICIPATION } from "./survey-configuration-urls";
import { SURVEYS } from "./survey-urls";
import { REQUEST_CATEGORIZATION } from "./request-categorization-urls";

export const ADMIN = {
  SKILL_GENERATION: SKILL_GENERATION,
  SKILL_CATEGORY: SKILL_CATEGORY,
  SURVEY_CONFIGURATION: SURVEY_CONFIGURATION,
  SURVEY_PARTICIPATION: SURVEY_PARTICIPATION,
  SURVEYS: SURVEYS,
  REQUEST_CATEGORIZATION: REQUEST_CATEGORIZATION,
}